export default __webpack_public_path__ + "static/media/Mark-6-Blueprints-02.c4627ff4.jpg";